import PropTypes from 'prop-types';
import NumberCellEditor from './NumberCellEditor';

function NumericCellEditor(props) {
  return (
    // eslint-disable-next-line react/destructuring-assignment
    <NumberCellEditor {...props} componentProps={{ ...props.componentProps, stringMode: true }} />
  );
}

NumericCellEditor.propTypes = {
  componentProps: PropTypes.shape({}),
};

export default NumericCellEditor;
